export const findTagKeyAndValue = (text: string): { key: string; value: string | undefined } => {
  const colonIdx = text.indexOf(':');
  if (colonIdx === -1) {
    return { key: text, value: undefined };
  }
  return { key: text.slice(0, colonIdx), value: text.slice(colonIdx + 1) };
};
